import { z } from 'zod';
export const UsageHistoryQuerySchema = z.object({
    category: z.enum(['ai', 'slots']).default('ai'),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(50).default(20),
});
export const UsageHistoryDataSchema = z.object({
    balances: z.object({
        aiCredits: z.number().int(),
        universal: z.number().int(),
        invitation: z.number().int(),
        thankyou: z.number().int(),
    }),
    transactions: z.array(z.object({
        id: z.string(),
        type: z.enum(['CHARGE', 'USE', 'RESTORE', 'REVOKE', 'BONUS']),
        amount: z.number().int(),
        balanceAfter: z.number().int().nullable(),
        description: z.string().nullable(),
        createdAt: z.iso.datetime(),
    })),
    pagination: z.object({
        page: z.number().int(),
        pageSize: z.number().int(),
        total: z.number().int(),
        totalPages: z.number().int(),
        hasNext: z.boolean(),
        hasPrev: z.boolean(),
    }),
});
//# sourceMappingURL=usage-history.js.map